export class UserDataChangesListLoad {
  public static readonly type = '[User Data Changes List] Load';
  constructor(public payload: { email: string }) {}
}

export class UserDataChangesListInitialState {
  public static readonly type = '[User Data Changes List] Set initial state';
}
